import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';
import {ARRAY, ENUM, INTEGER, OPTIONAL, STRING, TUPLE, guard} from '@acng/frontend-rubicon';
import {URLSearchParams} from '@acng/frontend-bounty/net/url.js';
import {size} from '@acng/frontend-bounty/std/array.js';

import {ctxMovie} from '../context/movie.js';
import {Actor} from '../../layout/context/list.js';
import {cdn} from '../../core/service/cdn.js';
import {ListItem, compile} from '../service/template.js';
import {user} from 'acng/userPool/service/user.js';
import {STYLE_EMPTY, swapClass} from 'acng/layout/service/style.js';
import {STYLE_INIT} from 'acng/layout/style/flags.js';

/**
 * @group DOM Attribute
 */
export const MOVIE_MORE = 'movie-more';

AttributeSetup(MOVIE_MORE, (name) => {
  const watchGallery = Watch(`[${name}]`, ctxMovie);
  const provideList = Actor();
  const syntax = /^(nickname|recommendation)(?::(\d+))?$/;

  AttributeLink(name, (element, value) => {
    const match = syntax.exec(value);
    ASSERT: {
      guard(
        match,
        TUPLE(
          STRING,
          ENUM(
            /**
             * @type {const}
             */ (['nickname', 'recommendation']),
          ),
          OPTIONAL(STRING),
        ),
      );
    }
    const [, type, limit = '16'] = match;
    const fsk = `${user?.getListFsk()}`;
    const params = new URLSearchParams({type, limit, fsk});

    watchGallery(element, (element, movie) => {
      /**
       * @param {number} offset
       */
      const more = async (offset) => {
        if (offset) {
          return [];
        }

        //@ts-ignore
        const {data: list} = await cdn(`/api/movie/mores/${movie.id}?${params}`);
        ASSERT: guard(list, ARRAY(INTEGER), 'more movies id list');

        const length = size(list);

        swapClass(element, STYLE_INIT, false);

        if (swapClass(element, STYLE_EMPTY, length < 3)) {
          return [];
        }

        return list;
      };

      swapClass(element, STYLE_INIT, true);
      provideList(element, more, ListItem);
    });
  });

  return compile;
});
